import { Component, EventEmitter, Input, OnInit, Output } from "@angular/core";
import { AppService } from "src/app/core/services/app.service";
import { FocuslinkService } from "src/app/core/services/focuslink.service";
import { OOVenueService } from "src/app/core/services/venue-service";
import { OOOrderType } from "src/app/shared/models/oo-order-type";
import { OOOrderTypeThrottle } from "src/app/shared/models/oo-order-type-throttle";

@Component({
	selector: "app-order-type-throttling",
	templateUrl: "./order-type-throttling.component.html",
	styleUrls: ["../../../../commandcenter.scss"],
})
export class OrderTypeThrottlingComponent implements OnInit {
	@Input() orderType: OOOrderType;
	@Output() orderTypeChange = new EventEmitter<OOOrderType>();

	@Input() changesToSave: boolean;
	@Output() changesToSaveChange = new EventEmitter<boolean>();

	constructor(public app: AppService, private focuslink: FocuslinkService, public venueSvc: OOVenueService) {}

	ngOnInit(): void {}

	async orderTypeThrottleAdd() {
		this.orderType.ooOrderTypeThrottles.push(
			new OOOrderTypeThrottle({
				orderTypeKey: this.orderType.key,
			})
		);
	}

	async deleteThrottle(rec: OOOrderTypeThrottle) {
		await this.focuslink.orderTypeThrottleDelete(this.venueSvc.venueKey, this.orderType.key, rec.guid);
		const ottIdx = this.orderType.ooOrderTypeThrottles.findIndex((i) => i.guid === rec.guid);
		this.orderType.ooOrderTypeThrottles.splice(ottIdx, 1);
	}
}
